import React from 'react';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import HeadingAndSupportingTextWithActions, {
  HeadingAndSupportingTextWithActionsProps,
} from '../HeadingAndSupportingText/HeadingAndSupportingTextWithActions';
import Calculator, { CalculatorProps } from '../Calculator/Calculator';

interface ContentWithCalculatorProps {
  heading: HeadingAndSupportingTextWithActionsProps['heading'];
  supportingText: HeadingAndSupportingTextWithActionsProps['supportingText'];
  subHeading: HeadingAndSupportingTextWithActionsProps['subHeading'];
  actions: HeadingAndSupportingTextWithActionsProps['actions'];
  calculator: CalculatorProps;
}

const ContentWithCalculator = ({
  heading,
  supportingText,
  subHeading,
  actions,
  calculator,
}: ContentWithCalculatorProps): JSX.Element => (
  <Grid
    borderRadius='radius-xl'
    background='alpha-white-light-50'
    overflow='hidden'
    maxWidthLg='width-md'
  >
    <Stack
      padding='spacing-7xl'
      justify='center'
      align='center'
      columnsLg={12}
      paddingSm={['spacing-3xl', 'spacing-4xl']}
    >
      <Stack>
        <HeadingAndSupportingTextWithActions
          heading={heading}
          supportingText={supportingText}
          subHeading={subHeading}
          subHeadingGap='spacing-lg'
          actions={actions}
          direction='column'
          justify='flex-start'
          align='flex-start'
        />
      </Stack>
    </Stack>
    <Stack columnsLg={12}>
      <Calculator {...calculator} />
    </Stack>
  </Grid>
);

export default ContentWithCalculator;
